import { render, staticRenderFns } from "./EventEditor.vue?vue&type=template&id=39c02d7a"
import script from "./EventEditor.vue?vue&type=script&lang=js"
export * from "./EventEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports